/* global window, FB, document */
declare global {
  interface Window {
    FB: any;
    fbAsyncInit: any;
  }
}

const VERSION = "v8.0";
const SIGN_IN_OPTIONS = {
  scope: "email"
};

interface FacebookLoginResponse {
  authResponse: {
    accessToken: string;
    userID: string;
    expiresIn: number;
    signedRequest: string;
    graphDomain: string;
    data_access_expiration_time: number;
  };
  status: "connected" | "not_authorized";
}

function load(appId: string | undefined) {
  return new Promise(resolve => {
    window.fbAsyncInit = function() {
      // eslint-disable-line func-names
      window.FB.init({
        appId,
        xfbml: false,
        version: VERSION,
        cookie: true
      });
      window.FB.AppEvents.logPageView();
      resolve();
    };
    (function(d, s, id) {
      const fjs: any = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      const js: any = d.createElement(s);
      js.id = id;
      js.src = "//connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  });
}

export function getLoginStatus() {
  return new Promise(resolve => {
    window.FB.getLoginStatus((responseStatus: any) => {
      resolve(responseStatus);
    });
  });
}

function signIn(): Promise<FacebookLoginResponse> {
  return new Promise(resolve => {
    window.FB.login((response: FacebookLoginResponse) => resolve(response), SIGN_IN_OPTIONS);
  });
}
function signOut() {
  return new Promise(resolve => {
    window.FB.logout((response: any) => resolve(response));
  });
}

export { load, signIn, signOut, FacebookLoginResponse };
